import { Spinner } from '@creditornot/cb-ingredients';
import { Typography as T } from '@creditornot/cb-ingredients';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ScientistError from 'common/illustrations/ScientistError';

type LoadingSpinnerProps = {
  isGeneratingSpreadsheetFromMenu: boolean;
  isUploading: boolean;
  uploadProgress: number;
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const Illustration = styled(ScientistError)`
  width: 100%;
  max-width: 375px;
  margin-block-end: 24px;
`;

export const LoadingSpinner = ({
  isGeneratingSpreadsheetFromMenu,
  isUploading,
  uploadProgress,
}: LoadingSpinnerProps) => {
  const intl = useIntl();
  const loadingText = React.useMemo<string>(() => {
    if (isUploading) {
      return intl.formatMessage({ id: 'shared-menu.editor.importer.table-view.uploading' });
    }

    if (isGeneratingSpreadsheetFromMenu) {
      return intl.formatMessage({ id: 'shared-menu.editor.importer.entrypoint.loading-from-menu' });
    }

    return intl.formatMessage({ id: 'shared-menu.editor.importer.entrypoint.loading' });
  }, [intl, isGeneratingSpreadsheetFromMenu, isUploading]);
  return (
    <Root>
      <Spinner size="extraLarge" />
      <Illustration />
      <T.Body3 fontWeight="bold">
        {loadingText} {!isGeneratingSpreadsheetFromMenu && `(${uploadProgress}%)`}
      </T.Body3>
    </Root>
  );
};
